const Pictures = {
  logo: require("./images/creative-balloons-logo.png"),
  mii: require("./images/make-in-india.jpg"),
  sec2: {
    img1: require("./images/natureBusiness.png"),
    img2: require("./images/group.jpg"),
    img3: require("./images/globe.png"),
    img4: require("./images/gst.png"),
    img5: require("./images/establishment.png"),
    img6: require("./images/incomeGraph.png"),
  },
  sec4: {
    img1: require("./images/balloon10.jpg"),
    img2: require("./images/Costumes14.jpg"),
    img3: require("./images/sec4Img3.jpg"),
    img4: require("./images/InflatableBounce1.jpg"),
  },

  sec6: {
    img1: require("./images/homeContact-BG.jpeg"),
  },

  ContactUs: {
    img1: require("./images/ContactImg.jpg"),
  },
  AboutUs: {
    img1: require("./images/aboutImg.jpg"),
  },
};
export default Pictures;
